import React from 'react';
import styles from './Login.module.css';

const Login = () => {
  return (
    <div className={styles.login}>
      {/* Header */}
      <section className={styles.header}>
        <h1 className={styles.pageTitle}>Member Login</h1>
        <p className={styles.pageSubtitle}>Access your IMDF member dashboard</p>
      </section>

      {/* Coming Soon */}
      <section className={styles.formSection}>
        <div className={styles.comingSoon}>
          <div className={styles.comingSoonIcon}>🔒</div>
          <h2>Coming Soon</h2>
          <p>Member login functionality will be available soon.</p>
          <p>Please check back later for secure access to your IMDF dashboard.</p>
        </div>
      </section>
    </div>
  );
};

export default Login;